import styled from "styled-components";
import { Table } from "semantic-ui-react";

export const SemanticTable = styled(Table)`
  padding: 1rem 1rem;
  margin-left: auto !important;
`;
